module.exports = __webpack_public_path__ + "img/settings-black.6b234a8c.svg";